import { Tooltip } from '@iwoca/orion';
import classnames from 'classnames';

interface InputTooltipProps {
    overlayText: string | React.ReactElement;
    'data-testid'?: string;
    tooltipClassName?: string;
    overlayPlacement?: React.ComponentProps<typeof Tooltip>['placement'];
}

const InputTooltip = (props: InputTooltipProps) => {
    return (
        <div className="input-tooltip">
            <Tooltip
                className={classnames('tooltip-box', props.tooltipClassName)}
                placement="top"
                strategy="absolute"
                content={props.overlayText}
                {...props}
            />
        </div>
    );
};

export default InputTooltip;
